<script>
    import { getContext } from 'svelte';
    import Button from 'components/Button';

    export let onClose = () => {};

    const { close } = getContext('simple-modal');

    function handleClose() {
        onClose();
        close();
    }
</script>

<div class="modal">
    <div class="modal-content">
        <h2 class="modal-content__title">Contact us</h2>
        <div class="modal__desc">
            <p>Standard Credit is a web-based lender operating across the Caribbean.</p>

            <!-- Trinidad & Tobago -->
            <div class="country-section">
                <h3 class="country-section__title">Trinidad & Tobago</h3>
                <div class="contacts">
                    <div class="contacts__contact">
                        <div class="contacts__name">Phone</div>
                        <a href="tel:+18682990219" class="contacts__number">868 299 0219</a>
                    </div>
                    <div class="contacts__contact">
                        <div class="contacts__name">Email</div>
                        <a href="mailto:info@standardtt.com" class="contacts__number">info@standardtt.com</a>
                    </div>
                    <div class="contacts__contact">
                        <div class="contacts__name">WhatsApp</div>
                        <a href="https://wa.me/18682500654" target="_blank" class="contacts__number">868 250 0654</a>
                    </div>
                </div>
            </div>

            <!-- Barbados -->
            <div class="country-section">
                <h3 class="country-section__title">Barbados</h3>
                <div class="contacts">
                    <div class="contacts__contact">
                        <div class="contacts__name">Phone</div>
                        <a href="tel:+12464307001" class="contacts__number">246 430 7001</a>
                    </div>
                    <div class="contacts__contact">
                        <div class="contacts__name">Email</div>
                        <a href="mailto:ourcommitmenttoyou@ansamcal.com" class="contacts__number">ourcommitmenttoyou@ansamcal.com</a>
                    </div>
                    <div class="contacts__contact">
                        <div class="contacts__name">WhatsApp</div>
                        <div class="contacts__info">
                            <a href="https://wa.me/12462348443" target="_blank" class="contacts__number">246 234 8443</a>,
                            <a href="https://wa.me/12462316266" target="_blank" class="contacts__number">246 231 6266</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Warranty & Service (shared) -->
            <div class="contact-group">
                <h4 class="contact-group__title">Warranty & Service:</h4>
                <p class="warranty-link-text">
                    For warranty and service support, please visit our
                    <a href="#/service-warranties" class="warranty-link">Service & Warranties</a> page.
                </p>
            </div>
        </div>
    </div>
    <div class="actions">
        <Button primary small onClick={handleClose}>OK</Button>
    </div>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .modal-content {
        margin-bottom: em(30);
        padding: em(30) em(30) 0 em(30);
        max-height: 70vh;
        overflow-y: auto;

        &__title {
            margin-bottom: em(25);
            font-size: em(20);
            font-weight: $fw-bold;
            color: $color-primary;
            line-height: 1.25;
        }

        :global(p) {
            margin-bottom: em(20);
        }
    }

    .country-section {
        margin-bottom: em(30);
        padding-bottom: em(25);
        border-bottom: 1px solid lighten($color-gray, 20%);

        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
        }

        &__title {
            font-size: em(18);
            font-weight: $fw-bold;
            color: $color-primary;
            margin-bottom: em(20);
        }
    }

    .contact-group {
        margin-bottom: em(25);

        &:last-child {
            margin-bottom: 0;
        }

        &__title {
            font-size: em(15);
            font-weight: $fw-medium;
            color: $color-black;
            margin-bottom: em(15);
        }
    }

    .contacts {
        display: grid;
        justify-content: flex-start;
        grid-template-columns: 1fr;
        gap: em(15);

        @include for-tablet-portrait-up {
            grid-template-columns: 1fr 1fr 1fr;
        }

        &__contact {
            font-size: em(14);
        }

        &__name {
            margin-bottom: em(8);
            color: $color-gray-text;
            font-weight: $fw-medium;
            font-size: em(12);
        }

        &__number {
            font-weight: $fw-bold;
            color: $color-primary;
            text-decoration: none;
            font-size: em(14);

            &:hover {
                text-decoration: underline;
            }
        }

        &__info {
            font-weight: $fw-bold;
            color: $color-primary;
            line-height: 1.5;
            font-size: em(14);

            a {
                color: $color-primary;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .warranty-link-text {
        font-size: em(14);
        color: $color-gray-text;
        line-height: 1.5;
        margin: 0;
    }

    .warranty-link {
        color: $color-primary;
        font-weight: $fw-bold;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .actions {
        padding: em(10) em(25);
        border-radius: 0 0 em(25) em(25);
        background: $color-gray-light;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;
    }
</style>
